import { StyleSheet } from "react-native"
import { color, palette, spacing } from "../../theme"

export const styles = StyleSheet.create({
  buttons: {
    marginTop: 20,
    width: "100%",
  },
  closeButton: {
    marginLeft: spacing[4],
    paddingHorizontal: spacing[4],
  },
  closeButtonIcon: {
    color: color.primary,
  },
  container: {
    alignItems: "center",
    backgroundColor: color.background,
    borderRadius: spacing[4],
    marginBottom: spacing[2],
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: spacing[9],
    paddingTop: spacing[8],
    padding: 40,
    width: 464,
  },
  desc: {
    fontSize: 18,
  },
  heading: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: spacing[4],
  },
  image: {
    color: palette.Red,
  },
  imageWrap: {
    alignItems: "center",
    backgroundColor: palette.Red,
    borderRadius: 58,
    height: 116,
    justifyContent: "center",
    opacity: 0.2,
    width: 116,
  },
  textWrapper: {
    alignItems: "center",
    marginBottom: spacing[5],
    marginTop: 56,
  },
  topButtons: {
    flexDirection: "row",
    marginLeft: 300,
  },
})
